import axios from 'axios'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import { AuthenticationModel } from '../models/AuthenticationModel'

const AUTH_URL = process.env.REACT_APP_API_NET;
const API_URL_IMAGE_PUBLIC = 'https://localhost:7092/img/';

export async function login(username: string, password: string) {
  try {
    const response = await axios.post<AuthenticationModel>(`${AUTH_URL}Authentication`, { username, password });

    return response; // Devuelve toda la respuesta de Axios, incluyendo `status`, `data`, etc.
  } catch (error: any) {
    console.error("Error en la solicitud de login:", error);
    if (error.response) {
      console.error("Error en la respuesta del servidor:", error.response.data);
    } else if (error.request) {
      console.error("No se recibió respuesta del servidor. Revisa si el backend está corriendo.");
    } else {
      console.error("Error al configurar la solicitud:", error.message);
    }
    throw error;
  }
}



export async function requestPassword(username: string) {
  return await axios.post(`${AUTH_URL}recover`, { username });
}
export async function restorePassword(password: string, confirmPassword: string, token: string) {
  return await axios.post<AuthenticationModel>(`${AUTH_URL}reset/${token}`, { password, confirm_password: confirmPassword });
}

export async function getUserByTokend() {
  try {
    console.log("Solicitando información del usuario...");
    const response = await axios.get(`${AUTH_URL}users/me`);
    const random = Math.random() * 40;

    const {
      data: {
        id,
        first_name,
        father_last_name,
        mother_last_name,
        alias,
        email,
        phone,
        roles,
        profile_photo,
        active,
        company: { code },
      },
    } = response.data;

    const user = {
      id: id,
      first_name: first_name,
      father_last_name: father_last_name,
      mother_last_name: mother_last_name,
      alias: alias,
      email: email,
      phone: phone,
      company: code,
      roles: roles,
      active: active,
      profile_photo: profile_photo
        ? `${API_URL_IMAGE_PUBLIC}${profile_photo}?${random}`
        : toAbsoluteUrl('/media/avatars/blank.png'),
    };

    return user;
  } catch (error) {
    console.error("Error al obtener el usuario por token:", error);
    throw error;
  }
}

export async function getUserByToken() {
  try {
    const response = await axios.get(`${AUTH_URL}TypeCollaborator`);

    const {
      data: {
        id,
        code,
        description,
        status,
        statusId,
        createdAt,
        updatedAt
      },
    } = response.data;

    const user = {
      id: id,
      code: code,
      description: description,
      status: status,
      statusId: statusId,
      createdAt: createdAt,
      updatedAt: updatedAt
    };
    return user;
  } catch (error) {
    console.error("Error al obtener el usuario por token:", error);
    throw error;
  }
}